import { connect } from 'react-redux'
import { actions } from 'appRedux/modules/Product'
import { actions as actionsModal } from 'appRedux/modules/Modal'
import ProductList from './ProductList'


const mapStateToProps = (state, ownProps) => ({
	products: state.Product.products,
	products_loaded: state.Product.loaded,

	result: state.UserOrders.add_single_result,
});
const mapDispatchToProps = (dispatch, ownProps) => ({ 
	onProductListLoadRequest: () => dispatch(actions.loadListRequest()), 
	// modal
	onModalOpen: (id) => dispatch(actionsModal.toggleModal(id, true)),
});


export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
